export default "__VITE_ASSET__cb180632__"